var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "services-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg services",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "services") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9,8V24L16,32,2.1,24V8L16,0ZM16,3.6,5.2,9.8V22.2L16,28.4l10.8-6.2V9.8Zm0,20.1A7.7,7.7,0,1,1,23.7,16,7.64,7.64,0,0,1,16,23.7Zm0-3.1A4.6,4.6,0,1,0,11.4,16,4.59,4.59,0,0,0,16,20.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.c22cc4c2aba8fafcb49f50a7c0d0dc99.svg";
export { ForwardRef as ReactComponent };